import React, { FC } from "react";
import styled from "styled-components";

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  width?: string;
  height?: string;
  borderRadius?: string;
  objectFit?: "fill" | "contain" | "cover" | "none" | "scale-down";
  boxShadow?: string;
}

const StyledImage = styled.img<ImageProps>`
  width: ${({ width }) => width || "auto"};
  height: ${({ height }) => height || "auto"};
  border-radius: ${({ borderRadius }) => borderRadius || "0"};
  object-fit: ${({ objectFit }) => objectFit || "cover"};
  box-shadow: ${({ boxShadow }) => boxShadow || "none"};
  display: block;
  max-width: 100%;
`;

const Image: FC<ImageProps> = (props) => {
  return <StyledImage {...props} />;
};

export default Image;
